"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createGlobalVirtualCategory = void 0;
const routes_1 = require("../../routes");
const createGlobalVirtualCategory = (client) => async (data) => {
    const url = routes_1.ENDPOINTS.CREATE_GLOBAL_VIRTUAL_CATEGORY.applyParams();
    const response = await client.post(url, data);
    return response.data;
};
exports.createGlobalVirtualCategory = createGlobalVirtualCategory;
